import React, {
    useContext,
    useCallback,
    useState,
    useEffect,
    useMemo,
} from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { ModalNextContext } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import {
    ViewModelServiceContext,
    withViewModelService,
    ViewModelForm,
} from '@xengage/gw-portals-viewmodel-react';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import {DigitalWizardCustPageTemplate} from 'gw-portals-wizard-components-ui';
import { useDependencies } from '@xengage/gw-portals-dependency-react';
import { withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { isCapabilityEnabled } from '@xengage/gw-portals-config-js';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import moment from 'moment';
// eslint-disable-next-line import/no-unresolved
import appConfig from 'app-config';
import { BreakpointTrackerContext } from '@jutro/layout';
import metadata from './SummaryPage.metadata.json5';
import summaryStyles from './SummaryPage.module.scss';
import messages from '../../FNOL.messages';
import AdjusterContent from './Component/AdjusterContent';
import AddNotePopup from './AddNotePopup';
import { LoaderExt } from 'gw-components-platform-react';
import usecpmiAnalytics from "../../../../hooks/usecpmiAnalytics"
import useGoogleAnalytics from '../../../../hooks/useGoogleAnalytics';

function FNOLSummaryPage(props) {
    const ModalNext = useContext(ModalNextContext);
    const translator = useTranslator();
    const { FNOLService } = useDependencies('FNOLService');
    const { ClaimService } = useDependencies('ClaimService');
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        wizardData: claimVM,
        updateWizardData,
        authHeader,
        history,
        history: {
            location: { state },
        },
    } = props;
    const { capabilitiesConfig } = appConfig;
    const [isLoading, setIsLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState('');
    const [popupNotesVM, updatePopupNotesVM] = useState(null);
    const [trackPageView] = usecpmiAnalytics();
    const [trackGAPageView] = useGoogleAnalytics();

    const newNoteViewModelObj = (initialData) => {
        return {
            note: viewModelService.create(
                initialData.note,
                'cc',
                'edge.capabilities.note.dto.NoteDTO'
            ),
        };
    };

    

    const getWhereLocation = useCallback(() => {
        if (
            !_.isEmpty(claimVM.lossLocation.value)
            && claimVM.lossLocation.city.value
            && claimVM.lossLocation.state.value.code
            && claimVM.lossLocation.country.value.code
        ) {
            
            const claimLoactionValue=`${translator({
                id:claimVM.lossLocation.state.value.name 
            })}`
            _.set(claimVM,'claimLoacationState',claimLoactionValue)
            return `${claimVM.lossLocation.city.value},
            
                ${translator({
        id:claimVM.lossLocation.state.value.name,
        defaultMessage:claimVM.lossLocation.state.value.name
    })},
                ${translator({
        id:claimVM.lossLocation.country.value.name,
        defaultMessage:claimVM.lossLocation.country.value.name
    })}`;
        }
        return '';
    }, [claimVM]);

    const getFnolInjury = useCallback(() => {
        if (
            !_.isEmpty(claimVM.value.lobs) &&
            claimVM.value.lobs.workersComp &&
            claimVM.value.lobs.workersComp.injuryIncident.description
        ) {
            return `${claimVM.value.lobs.workersComp.injuryIncident.description}`;
        } 
        return ' ';
    }, [claimVM]);

    const getFnolWhat = useCallback(() => {
        if (!_.isEmpty(claimVM.value.description)) {
            return `${claimVM.value.description}`;
        }
        return ' ';
    }, [claimVM]);

    const formatAMPM = (date) => {
        let hours = date.getHours() % 12;
        let minutes = date.getMinutes();
        const ampm = date.getHours() >= 12 ? 'PM' : 'AM';
        hours = hours || 12;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        const strTime = `${hours}:${minutes} ${ampm}`;
        return strTime;
    };

    const getFnolWhen = useCallback(() => {
        //const datetime = claimVM.value.lossDate;

        const time = formatAMPM(new Date());
       // const periodValue=moment.utc(claimVM.value.lossDate.toLocaleString());
        const lossDate=moment(claimVM.value.lossDate).format('MM/DD/YYYY');
        const whendateandtime = `${lossDate} ${time}`;
        return whendateandtime;
    }, []);

    const getfelonyText = useCallback(() => {
        return (
            <>
                <div className={summaryStyles.disclosureScrollbar}>

                    <div className={summaryStyles.heading}>Please scroll down to find disclosures to specific states.<br /></div ><br />
                    <div className={summaryStyles.fnolFelonly}>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in all states not specified below:</span>
                            {translator(messages.fnolNotSpecifiedStatesText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Arkansas:</span>
                            {translator(messages.fnolArkansaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}> Applicable in District of Columbia: </span>
                            {translator(messages.fnolColumbiaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Florida:</span>
                            {translator(messages.fnolFloridaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Minnesota: </span>
                            {translator(messages.fnolMinnesotaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in New Hampshire:</span>
                            {translator(messages.fnolHampshireText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in New Jersey:</span>
                            {translator(messages.fnolNewJerseyText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Oklahoma: </span>
                            {translator(messages.fnolOklahomaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Pennsylvania:</span>
                            {translator(messages.fnolPennsylvaniaText)}</p>
                        <p className={summaryStyles.commonheading}><span className={summaryStyles.subheading}>Applicable in Utah:</span>
                            {translator(messages.fnolUTText)}</p>
                        
                    </div>
                </div>
            </>
        );
    }, []);

    const getContactPerson = useCallback(() => {
        let phoneType;
        switch (claimVM.value.mainContact.primaryPhoneType) {
            case 'home':
                phoneType = claimVM.value.mainContact.homeNumber;
                break;
            case 'work':
                phoneType = claimVM.value.mainContact.workNumber;
                break;
            case 'mobile':
                phoneType = claimVM.value.mainContact.cellNumber;
                break;
            default:
                phoneType = '';
        }
        if (claimVM.value.mainContact.displayName && phoneType) {
            return `${claimVM.value.mainContact.firstName} ${claimVM.value.mainContact.lastName}, ${phoneType}`;
        }
        if (claimVM.value.mainContact.displayName) {
            return `${claimVM.value.mainContact.firstName} ${claimVM.value.mainContact.lastName}`;
        }
        return `${claimVM.value.mainContact.firstName} ${claimVM.value.mainContact.lastName}`|| ' '
    }, [claimVM]);

    const isVendorRepairOptionEnabled = useMemo(() => {
        const lossCause = _.get(claimVM.value, 'lossCause');
        return (
            !_.isNil(_.get(claimVM.value, 'lobs.personalAuto')) &&
            lossCause !== 'theftentire' &&
            isCapabilityEnabled({
                capabilitiesConfig,
                capabilityName: 'vendor',
            })
        );
    }, [capabilitiesConfig, claimVM]);

    const repairFacilityVisible = useCallback(() => {
        return (
            isVendorRepairOptionEnabled &&
            !_.isNil(_.get(claimVM.value, 'lobs.personalAuto.repairOption'))
        );
    }, [claimVM, isVendorRepairOptionEnabled]);

    const getRepairFacility = useCallback(() => {
        const repairOptionChoice = _.get(
            claimVM.value,
            'lobs.personalAuto.repairOption.repairOptionChoice'
        );
        if (!_.isNil(repairOptionChoice) && repairOptionChoice === 'NoRepair') {
            return translator(messages.fnolNoRepairRequested);
        }
        const repairFacility = _.get(
            claimVM.value,
            'lobs.personalAuto.repairOption.repairFacility'
        );
        if (_.isNil(repairFacility)) {
            return null;
        }
        const vendorName = repairFacility.contactName
            ? repairFacility.contactName
            : '';
        const vendorAddress = repairFacility.primaryAddress;
        const addressDetails = {
            addressLine1: vendorAddress.addressLine1,
            addressLine2: vendorAddress.addressLine2,
            addressLine3: vendorAddress.addressLine3,
            city: vendorAddress.city,
            state: vendorAddress.state,
            postalCode: vendorAddress.postalCode,
        };

        const formattedVendorAddress = Object.values(addressDetails)
            .filter((data) => data)
            .join(', ');
        return (
            <div>
                <p>{vendorName}</p>
                <p>{formattedVendorAddress}</p>
            </div>
        );
    }, [claimVM]);

    const initializeNotesVM = () => {
        if (!_.isEmpty(claimVM.adjusterNote.value)) {
            const getNotesVM = newNoteViewModelObj({
                note: {
                    claimNumber: claimVM.claimNumber.value,
                    subject: claimVM.adjusterNote.subject.value,
                    body: claimVM.adjusterNote.body.value,
                },
            });
            return updatePopupNotesVM(getNotesVM.note);
        }

        const getNotesVM = newNoteViewModelObj({
            note: {
                claimNumber: claimVM.claimNumber.value,
                subject: '',
                body: '',
            },
        });
        return updatePopupNotesVM(getNotesVM.note);
    };

    useEffect(() => {
        initializeNotesVM();
        // execute once
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=> {
        trackPageView("Summary","/summary")
    },[])

    useEffect(()=> {
        trackGAPageView("/fnol/summary","Summary")
    },[])

    const showModal = useCallback(
        async (getNotesVM) => {
            const componentProps = {
                title: translator(messages.dialogAddNoteToAdjuster),
                actionBtnLabel: messages.dialogOk,
                cancelBtnLabel: messages.dialogCancel,
                notesVM: getNotesVM,
                viewModelService: viewModelService,
            };

            const results = await ModalNext.showModal(
                <AddNotePopup {...componentProps} />
            );

            return results;
        },
        [ModalNext, viewModelService]
    );

    const updateNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.updateClaimNote(
                claimNumber,
                noteVM.value,
                authHeader
            )
                .then((response) => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNext.showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, ClaimService, authHeader, updateWizardData, ModalNext]
    );

    const handleEditNote = useCallback(() => {
        showModal(popupNotesVM)
            .then((updatedVM) => {
                const modifiedVM = viewModelService.clone(updatedVM);
                updateNoteData(modifiedVM);
            })
            .catch(_.noop);
    }, [popupNotesVM, viewModelService]);

    const handleDeleteNote = useCallback(() => {
        setIsLoading(true);
        const claimNumber = _.get(claimVM.value, 'claimNumber');
        const noteId = _.get(claimVM.value, 'adjusterNote.publicID');
        return ClaimService.deleteClaimNote(claimNumber, noteId, authHeader)
            .then((response) => {
                _.set(claimVM, 'adjusterNote.value', response);
                updateWizardData(claimVM);
                _.set(popupNotesVM, 'value', response);
                updatePopupNotesVM(popupNotesVM);
            })
            .catch(() => {
                ModalNext.showAlert({
                    title: messages.fnolNoteErrorHead,
                    message: messages.fnolNoteErrorMessage,
                    status: 'error',
                    icon: 'mi-error-outline',
                    confirmButtonText: commonMessages.ok,
                }).catch(_.noop);
                return false;
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [claimVM, ClaimService, authHeader, updateWizardData, popupNotesVM, ModalNext]);

    const saveNoteData = useCallback(
        (noteVM) => {
            setIsLoading(true);
            const claimNumber = _.get(claimVM.value, 'claimNumber');
            return ClaimService.createClaimNote(
                claimNumber,
                noteVM.value,
                authHeader
            )
                .then((response) => {
                    _.set(claimVM, 'adjusterNote.value', response);
                    updateWizardData(claimVM);
                    _.set(noteVM, 'value', response);
                    updatePopupNotesVM(noteVM);
                })
                .catch(() => {
                    ModalNext.showAlert({
                        title: messages.fnolNoteErrorHead,
                        message: messages.fnolNoteErrorMessage,
                        status: 'error',
                        icon: 'mi-error-outline',
                        confirmButtonText: commonMessages.ok,
                    }).catch(_.noop);
                    return false;
                })
                .finally(() => {
                    setIsLoading(false);
                });
        },
        [claimVM, ClaimService, authHeader, updateWizardData, ModalNext]
    );
    const addNotesToAdjuster = useCallback(() => {
        showModal(popupNotesVM)
            .then((updatedVM) => {
                const modifiedVM = viewModelService.clone(updatedVM);
                saveNoteData(modifiedVM);
            })
            .catch(_.noop);
    }, [popupNotesVM, viewModelService]);

    const getWhereLocationVisibility = useCallback(() => {
        if (!_.isEmpty(claimVM.lossLocation.value)) {
            return true;
        }
        return false;
    }, [claimVM]);

    const onNext = useCallback(() => {
        const claimLocationState=claimVM.claimLoacationState;
        setIsLoading(true);
        setLoadingMessage(translator(messages.fnolSubmitClaimDetails));
        const newClaimVM = _.clone(claimVM);
        if(_.get(newClaimVM.lossLocation.value,'country') !== 'JP') {
            _.unset(newClaimVM.lossLocation.value, 'addressLine1Kanji');
            _.unset(newClaimVM.lossLocation.value, 'addressLine2Kanji');
            _.unset(newClaimVM.lossLocation.value, 'cityKanji');
        }
        if(_.get(newClaimVM.mainContact.primaryAddress.value,'country') !== 'JP') {
            _.unset(newClaimVM.mainContact.primaryAddress.value, 'addressLine1Kanji');
            _.unset(newClaimVM.mainContact.primaryAddress.value, 'addressLine2Kanji');
            _.unset(newClaimVM.mainContact.primaryAddress.value, 'cityKanji');
        }
        _.set(newClaimVM, 'documents.value', []);
        if(newClaimVM.value.mainContact.primaryAddress.country !== "US"){
            newClaimVM.value.mainContact.primaryAddress.zipCode = newClaimVM.value.mainContact.primaryAddress.postalCode
            newClaimVM.value.mainContact.primaryAddress.postalCode = undefined
        }
        return (
            FNOLService.submitClaim(newClaimVM.value, authHeader)
                .then((response) => {
                    
                    claimVM.value = response;
                    const claimNumber = _.get(claimVM.value, 'claimNumber');
                    const { redirectPath } = state;
                    trackPageView("Confirmation", "/confirmation/claim#")
                    
                    return history.push({
                        pathname: `/confirmation/${claimNumber}`,
                        state: {
                            data: claimVM.value,
                            claimLocationState:claimLocationState,
                            redirectPath: redirectPath
                        },
                    });
                })
                .catch(() => {
                    
                    const claimNumber = _.get(claimVM.value, 'claimNumber');
                    const { redirectPath } = state;
                    return history.push({
                        pathname: `/contactAgent/${claimNumber}`,
                        state: {
                            redirectPath: redirectPath,
                        },
                    });
                })
                .finally(() => {
                    setIsLoading(false);
                })
        );
    }, [claimVM, FNOLService, authHeader, state, history]);

    const typeOfIncident = _.get(claimVM, 'lossCause.value.name');

    if(isLoading)
    {
        return <LoaderExt loaded={!isLoading}/>
    }

    const overrides = {
        '@field': {
            phoneWide: {
                labelPosition: 'top',
            },
        },
        fnolTypeOfIncident: {
            value: translator({
                id: typeOfIncident,
                defaultMessage: typeOfIncident,
            }),
        },
        addNotebtnDiv: {
            visible: _.isEmpty(claimVM.adjusterNote.value),
        },
        adjusterNoteDiv: {
            visible: !_.isEmpty(claimVM.adjusterNote.value),
        },
        fnolWhere: {
            visible: getWhereLocationVisibility(),
            value: getWhereLocation(),
        },
        fnolWhen: {
            value: getFnolWhen(),
            phoneWideTime: {
                labelPosition: 'top',
            },
        },
        fnolContactPerson: {
            value: getContactPerson(),
        },
        fnolWhat: {
            visible: !_.get(claimVM.value, 'onFastTrack'),
            value: getFnolWhat(),
        },
        fnolInjury: {
            visible: !_.get(claimVM.value, 'onFastTrack'),
            value: getFnolInjury(),
        },
        felonyTextId: {
            content: getfelonyText(),
        },

        summaryPageLoader: {
            loaded: !isLoading,
            loadingMessage: translator(loadingMessage),
        },
        fnolSummaryPage: {
            visible: !isLoading,
        },
        fnolRepairFacility: {
            visible: repairFacilityVisible(),
            value: repairFacilityVisible() ? getRepairFacility() : '',
        },
        adjusterContent: {
            handleEditNote,
            handleDeleteNote,
            claimVM,
        },
    };
    const resolvers = {
        resolveCallbackMap: {
            addNotesToAdjuster: addNotesToAdjuster,
        },
        resolveComponentMap: {
            adjustercontent: AdjusterContent,
        },
        resolveClassNameMap: summaryStyles,
    };

    const readValue = (id, path) => {
        return readViewModelValue(
            metadata.pageContent,
            claimVM,
            id,
            path,
            overrides
        );
    };

    let nextLabel = messages.fnolSubmitClaim;
    if (breakpoint === 'phoneWide' || breakpoint === 'phone') {
        nextLabel = messages.fnolSubmitClaimShort;
    }
    return (
        <WizardPage
            nextLabel={translator(nextLabel)}
            cancelLabel={translator(messages.fnolSaveandExit)}
            onNext={onNext}
            template={DigitalWizardCustPageTemplate}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={claimVM}
                overrideProps={overrides}
                onModelChange={updateWizardData}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
            />
        </WizardPage>
    );
}

FNOLSummaryPage.propTypes = wizardProps;
FNOLSummaryPage.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
};
export default withRouter(
    withAuthenticationContext(withViewModelService(FNOLSummaryPage))
);
